import React from "react";
import CoreH from "./CoreH";

export default function CoreH5(props) {
  return (
    <CoreH {...props} variant="h5" component="h5">
      {props?.children}
    </CoreH>
  );
}
